var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _line, _line2, _rect, _rect2, _rect3, _rect4, _rect5, _path9, _path10, _line3, _line4, _line5, _line6, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _path11, _rect15, _rect16, _rect17, _path12, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard1Frame7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 630,
    height: 353,
    viewBox: "0 0 630 353",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M337.36 217.985L337.842 132.04C337.77 130.847 338.528 128.638 342.14 129.354L512.038 129.354C513.786 128.981 517.939 129.534 520.575 134.726L564.019 195.156C565.356 197.021 568.841 200.751 572.078 200.751L628.472 200.751",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M292.617 218.209L293.101 132.183C293.187 130.988 292.453 128.777 288.829 129.494L118.795 129.494C117.051 129.121 112.889 129.674 110.192 134.872L66.0342 195.373C64.6742 197.24 61.1444 200.975 57.9057 200.975L1.46596 200.975",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M292.069 316.911L292.029 324.073C292.102 325.117 291.63 327.206 289.156 327.206L219.912 327.206C219.277 327.206 217.539 325.953 215.664 320.94C215.252 319.838 213.315 315.017 210.368 307.735M1.34942 221.79L21.2184 221.79M137.281 189.784L137.261 193.365L137.302 185.979M137.281 189.784L148.524 189.784M137.281 189.784L126.038 189.784M148.524 189.784L159.767 189.784C161.861 189.784 163.323 192.172 163.793 193.365C173.887 218.091 190.33 258.404 202.012 287.144M148.524 189.784L148.504 193.365L148.546 185.979M126.038 189.784L114.794 189.784C113.368 189.635 109.843 190.142 107.16 193.365L96.7392 205.787M126.038 189.784L126.018 193.365L126.059 185.979M96.7392 205.787L86.3185 218.209C85.1221 219.402 82.3484 221.79 80.8255 221.79L60.9565 221.79M96.7392 205.787L107.09 205.787L86.3883 205.787M41.0875 221.79L41.0611 226.49M41.0875 221.79L60.9565 221.79M41.0875 221.79L21.2184 221.79M60.9565 221.79L60.9301 226.49M21.2184 221.79L21.192 226.49M210.368 307.735L221.925 307.735M210.368 307.735C209.139 304.7 207.736 301.238 206.194 297.439M206.194 297.439L221.982 297.439M206.194 297.439C204.891 294.229 203.49 290.779 202.012 287.144M202.012 287.144L222.04 287.144",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M336.812 316.911L336.772 324.073C336.687 325.117 337.135 327.206 339.61 327.206L408.854 327.206C409.488 327.206 411.24 325.953 413.172 320.94C413.596 319.838 415.588 315.017 418.617 307.735M628.6 221.79L608.731 221.79M493.028 189.784L493.008 193.365L493.049 185.979M493.028 189.784L481.785 189.784M493.028 189.784L504.271 189.784M481.785 189.784L470.541 189.784C468.447 189.784 466.959 192.172 466.476 193.365C456.104 218.091 439.208 258.404 427.203 287.144M481.785 189.784L481.764 193.365L481.806 185.979M504.271 189.784L515.514 189.784C516.943 189.635 520.462 190.142 523.109 193.365L533.39 205.787M504.271 189.784L504.251 193.365L504.292 185.979M533.39 205.787L543.671 218.209C544.854 219.402 547.601 221.79 549.124 221.79L568.993 221.79M533.39 205.787L523.039 205.787L543.741 205.787M588.862 221.79L588.836 226.49M588.862 221.79L568.993 221.79M588.862 221.79L608.731 221.79M568.993 221.79L568.966 226.49M608.731 221.79L608.705 226.49M418.617 307.735L407.06 307.735M418.617 307.735C419.879 304.7 421.321 301.238 422.906 297.439M422.906 297.439L407.117 297.439M422.906 297.439C424.244 294.229 425.685 290.779 427.203 287.144M427.203 287.144L407.175 287.144",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M315.559 201.87L316.554 24.6092C316.558 23.8631 317.042 22.371 318.946 22.371L519.064 22.371C521.284 22.4456 525.73 21.8339 525.747 18.79C525.764 15.7461 525.809 7.6739 525.83 4.01826C525.755 3.12301 526.178 1.33249 528.462 1.33249L619.429 0.999998",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M315.056 201.87L316.052 24.6092C316.056 23.8631 315.589 22.371 313.689 22.371L113.875 22.371C111.657 22.4456 115.23 21.6537 115.247 18.6099C115.264 15.566 115.31 7.49375 115.33 3.83812C115.414 2.94286 107.008 1.33249 104.727 1.33249L11.518 1.15234",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M314.815 337.726L314.77 345.783C314.6 347.723 315.308 351.602 319.496 351.602L492.488 351.602C493.756 351.751 497.203 350.886 500.846 346.231L557.884 274.162C558.922 272.894 561.427 270.357 563.14 270.357L628.101 270.357",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M313.824 337.726L313.779 345.783C313.927 347.723 313.175 351.602 308.987 351.602L135.996 351.602C134.726 351.751 131.288 350.886 127.698 346.231L71.4696 274.162C70.4456 272.894 67.9693 270.357 66.256 270.357L1.29502 270.357",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 96.6099,
    y2: -0.5,
    transform: "matrix(1 1.15926e-09 -0.00561531 0.999984 532.626 22.5947)",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 96.6099,
    y2: -0.5,
    transform: "matrix(1 1.15926e-09 -0.00561531 0.999984 2.94336 22.595)",
    stroke: "#D9D9D9",
    strokeOpacity: 0.05
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1.92569,
    height: 24.9426,
    transform: "matrix(0.00360654 -0.999994 0.999956 0.0094223 215.205 129.522)",
    fill: "url(#paint0_linear_439_872)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1.7988,
    height: 50.1352,
    transform: "matrix(1 9.23499e-10 -0.00561531 0.999984 315.53 37.4233)",
    fill: "url(#paint1_linear_439_872)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1.81825,
    height: 56.5485,
    transform: "matrix(0.00447538 -0.999995 -0.999822 -0.0166023 421.051 352.536)",
    fill: "url(#paint2_linear_439_872)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 1.81825,
    height: 56.5434,
    transform: "matrix(0.00440648 -0.999995 1 -0.00341052 208.183 351.925)",
    fill: "url(#paint3_linear_439_872)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 1.92569,
    height: 24.7772,
    transform: "matrix(-0.00360657 0.999994 -0.999956 -0.00942233 415.731 128.166)",
    fill: "url(#paint4_linear_439_872)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M423.54 296L413.152 322.842C412.492 324.342 410.778 327.342 409.195 327.342C407.612 327.342 401.94 327.342 399.302 327.342",
    stroke: "url(#paint5_linear_439_872)",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M205.399 296L215.787 322.842C216.446 324.342 218.161 327.342 219.744 327.342C221.327 327.342 226.999 327.342 229.637 327.342",
    stroke: "url(#paint6_linear_439_872)",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 423.045,
    y1: 297.5,
    x2: 407.216,
    y2: 297.5,
    stroke: "url(#paint7_linear_439_872)"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 15.8288,
    y2: -0.5,
    transform: "matrix(1 0 -2.31664e-10 -1 205.894 297)",
    stroke: "url(#paint8_linear_439_872)"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 419.088,
    y1: 307.5,
    x2: 407.216,
    y2: 307.5,
    stroke: "#D9D9D9"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 11.8716,
    y2: -0.5,
    transform: "matrix(1 0 -2.31664e-10 -1 209.851 307)",
    stroke: "#D9D9D9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 292.458,
    y: 267.842,
    width: 0.9893,
    height: 1,
    fill: "#D9D9D9"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 292.458,
    y: 255,
    width: 0.9893,
    height: 1,
    fill: "#D9D9D9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 315.211,
    y: 267.842,
    width: 0.9893,
    height: 1,
    fill: "#D9D9D9"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 315.211,
    y: 255,
    width: 0.9893,
    height: 1,
    fill: "#D9D9D9"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 336.976,
    y: 267.842,
    width: 0.9893,
    height: 1,
    fill: "#D9D9D9"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 336.976,
    y: 255,
    width: 0.9893,
    height: 1,
    fill: "#D9D9D9"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 10.9543,
    height: 4.47636,
    rx: 2,
    transform: "matrix(1 2.05293e-10 -0.00561531 0.999984 613.999 192.918)",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 10.9543,
    height: 4.47636,
    rx: 2,
    transform: "matrix(1 2.05293e-10 -0.00561531 0.999984 599.234 192.918)",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 10.9543,
    height: 4.47636,
    rx: 2,
    transform: "matrix(1 2.05293e-10 -0.00561531 0.999984 584.469 192.918)",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M569.7 193.664C569.703 193.252 570.039 192.918 570.451 192.918L578.659 192.918C579.763 192.918 580.654 193.813 580.648 194.918L580.644 195.568C580.638 196.577 579.816 197.394 578.808 197.394L573.41 197.394C571.35 197.394 569.689 195.724 569.7 193.664Z",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 10.9543,
    height: 4.47636,
    rx: 2,
    transform: "matrix(-1 -2.05293e-10 -0.00561531 0.999984 16.752 192.918)",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 10.9543,
    height: 4.47636,
    rx: 2,
    transform: "matrix(-1 -2.05293e-10 -0.00561531 0.999984 31.5166 192.918)",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 10.9543,
    height: 4.47636,
    rx: 2,
    transform: "matrix(-1 -2.05293e-10 -0.00561531 0.999984 46.2812 192.918)",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0412 193.664C61.0435 193.252 60.7114 192.918 60.2994 192.918L52.0911 192.918C50.9866 192.918 50.0861 193.813 50.0799 194.918L50.0763 195.568C50.0706 196.577 50.8834 197.394 51.8917 197.394L57.29 197.394C59.3502 197.394 61.0297 195.724 61.0412 193.664Z",
    fill: "#D9D9D9",
    fillOpacity: 0.05
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_439_872",
    x1: 0.962847,
    y1: 0,
    x2: 0.962847,
    y2: 24.9426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_439_872",
    x1: 0.899399,
    y1: 0,
    x2: 0.899399,
    y2: 50.1352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_439_872",
    x1: 0.909125,
    y1: 0,
    x2: 0.909125,
    y2: 56.5485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_439_872",
    x1: 0.909125,
    y1: 0,
    x2: 0.909125,
    y2: 56.5434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_439_872",
    x1: 0.962847,
    y1: 0,
    x2: 0.962847,
    y2: 24.7772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_439_872",
    x1: 419.088,
    y1: 307.842,
    x2: 405.427,
    y2: 328.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_439_872",
    x1: 209.851,
    y1: 307.842,
    x2: 223.511,
    y2: 328.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_439_872",
    x1: 423.045,
    y1: 296.5,
    x2: 407.216,
    y2: 296.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_439_872",
    x1: 0,
    y1: 0.5,
    x2: 15.8288,
    y2: 0.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard1Frame7);
export default __webpack_public_path__ + "static/media/card1-frame7.c2a29be061227543c2e8e94faedc848b.svg";
export { ForwardRef as ReactComponent };